import { useEffect } from 'react'

/**
 * Hook that listens for Supabase Realtime change events on specific tables
 * and calls a refresh callback when changes are detected.
 *
 * Usage:
 *   useRealtimeRefresh(['invoices', 'credit_notes'], loadData)
 */
export function useRealtimeRefresh(tables: string[], onRefresh: () => void) {
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail
      if (tables.includes(detail.table)) {
        console.log(
          `[useRealtimeRefresh] ${detail.table} ${detail.eventType} — refreshing`,
        )
        onRefresh()
      }
    }
    window.addEventListener('supabase-change', handler)
    return () => window.removeEventListener('supabase-change', handler)
  }, [tables, onRefresh])
}
